<template>
    <vx-expandable-card toggleable id="launch" :active="active" class="relative">
        <template v-slot:header>
            <div class="pb-1 lg:pb-0">Launch</div>
        </template>
        <template v-slot:content>
            <quick-blast-launch-success v-if="props.success"></quick-blast-launch-success>
            <template v-else>
                <quick-blast-launch-preview
                    v-model:name="campaignName"
                    :mediaUrl="props.mediaUrl"
                    :bodyMessage="props.bodyMessage"
                    :estimation="estimation"
                    :groupIds="props.groupIds"
                    @save:name="emit('save:name')"
                ></quick-blast-launch-preview>

                <div class="flex flex-col-reverse mt-4 lg:mt-12 lg:flex-row">
                    <vx-button
                        size="xl"
                        color="muted"
                        class="mt-2 lg:mb-0 lg:mt-0 lg:mr-2 lg:w-36"
                        type="button"
                        @click="testing = true"
                        data-test="launch-test"
                    >
                        Send Test
                        <font-awesome-icon widthAuto :icon="faFlaskVial"></font-awesome-icon>
                    </vx-button>
                    <vx-button
                        :loading="props.submiting"
                        :disabled="props.submiting"
                        size="xl"
                        :color="props.scheduled ? 'info' : 'primary'"
                        class="grow"
                        type="button"
                        @click="emit('submit')"
                        data-test="launch-submit"
                    >
                        {{ props.scheduled ? 'Schedule Message' : 'Send Message' }}
                        <font-awesome-icon widthAuto :icon="faRocketLaunch"></font-awesome-icon>
                    </vx-button>
                </div>
            </template>
            <div v-if="props.success && !props.orgUnitId && !props.groupId">
                <div class="absolute inset-x-5 -bottom-0.5 z-10 overflow-hidden">
                    <svg width="1495px" height="5px" viewBox="0 0 1495 5" class="translate-y-1 stroke-slate-400/90">
                        <line
                            x1="5"
                            x2="1495"
                            y1="2.5"
                            y2="2.5"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-dasharray="0, 10"
                        ></line>
                    </svg>
                    <svg
                        width="1495px"
                        height="5px"
                        viewBox="0 0 1495 5"
                        class="stroke-slate-300 absolute top-0 translate-y-px"
                    >
                        <line
                            x1="5"
                            x2="1495"
                            y1="2.5"
                            y2="2.5"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-dasharray="0, 10"
                        ></line>
                    </svg>
                </div>
            </div>
        </template>
    </vx-expandable-card>
    <message-builder-test
        v-model:visible="testing"
        :orgUnitId="props.orgUnitId"
        :groupId="props.groupId"
        :bodyMessage="props.bodyMessage"
        :mediaUrl="props.mediaUrl"
        :mediaContentType="props.mediaContentType"
    ></message-builder-test>
</template>

<script setup>
import { ref } from 'vue';
import { faFlaskVial, faRocketLaunch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxExpandableCard } from '@voxie/frontend-components';
import QuickBlastLaunchPreview from './QuickBlastLaunchPreview.vue';
import QuickBlastLaunchSuccess from './QuickBlastLaunchSuccess.vue';
import MessageBuilderTest from '~/components/general/message-builder/modals/MessageBuilderTest.vue';

const props = defineProps({
    orgUnitId: {
        type: Number,
    },
    groupId: {
        type: String,
    },
    active: {
        type: Boolean,
        default: false,
    },
    mediaUrl: {
        type: String,
        required: false,
    },
    mediaContentType: {
        type: String,
        required: false,
    },
    bodyMessage: {
        type: String,
        required: true,
    },
    success: {
        type: Boolean,
        default: false,
    },
    submiting: {
        type: Boolean,
        default: false,
    },
    estimation: {
        required: false,
    },
    // not to be confused with groupId
    groupIds: {
        type: Array,
    },
    scheduled: {
        type: Boolean,
        default: false,
    },
});

const testing = ref(false);

const campaignName = defineModel('name', {
    type: String,
    required: true,
});

const emit = defineEmits(['submit', 'save:name']);
</script>
